// Profile
import { trendSWRFetch } from 'api';
import PageLoader from 'components/common/Loader/PageLoader';
import { ProfileTabs, PROFILE_TABS } from 'constants/profile';
import React, { useState } from 'react';
import { trackEvent } from 'services/analytics';
import useSWR from 'swr';
import { PersonalProfileResponse } from 'types/profile';
import About from './About';
import Header from './Header';
import Portfolio from './PersonalPortfolio';
import styles from './Profile.module.sass';
import Promotions from './Promotions';

export interface ProfileProps {}

const Profile: React.FC<ProfileProps> = () => {
  const [tab, setTab] = useState<PROFILE_TABS>(PROFILE_TABS.PORTFOLIO);
  const { data: creatorProfile } = useSWR<PersonalProfileResponse>(
    `/creator/profile`,
    trendSWRFetch
  );

  const handleTabChange = (tabName: PROFILE_TABS) => {
    setTab(tabName);
    trackEvent('Creator Selects Profile Tab', { tabName });
  };

  return typeof creatorProfile !== 'undefined' ? (
    <div className={styles.profile}>
      {/* Header Section */}
      <Header
        tabs={ProfileTabs}
        selected={tab}
        onTabSelect={handleTabChange}
        username={creatorProfile.username}
        creatorId={creatorProfile.creatorId}
        firstName={creatorProfile.firstName}
        lastName={creatorProfile.lastName}
        profilePicture={creatorProfile.profilePicture}
        address={creatorProfile.address}
        ageRange={creatorProfile.ageRange}
        overallRating={creatorProfile.overallRating}
      />
      {/* - Tab Sections - */}
      <div className={styles.tabSections}>
        {/* -- Profile Section */}
        {tab === PROFILE_TABS.PORTFOLIO && (
          <Portfolio
            profileType="personal"
            creatorId={creatorProfile.creatorId}
            creatorName={`${creatorProfile.firstName} ${creatorProfile.lastName}`}
            profilePicture={creatorProfile.profilePicture || ''}
            initialPortfolio={creatorProfile.portfolio}
          />
        )}
        {/* -- Skills & About Section */}
        {tab === PROFILE_TABS.ABOUT && (
          <About
            profileType="personal"
            about={creatorProfile.about}
            socials={creatorProfile.socials}
            environment={creatorProfile.environment}
            equipment={creatorProfile.equipment}
            socialCategories={creatorProfile.socialCategories}
            contentCategories={creatorProfile.contentCategories}
          />
        )}
        {/* -- Promotions Section  */}
        {tab === PROFILE_TABS.PROMOTIONS && (
          <Promotions
            level={creatorProfile.level}
            completedPartnershipCount={creatorProfile.completedPartnershipCount}
          />
        )}
      </div>
    </div>
  ) : (
    <PageLoader />
  );
};

export default Profile;
